import { Box } from '@material-ui/core'
import { Advantages } from '../components/home/advantages'
import { lan } from '../langs'
import React from 'react'
import SEO from '../components/seo'
import Header from '../layout/header'

const pl = {
  title: 'Blink Find - Wyszukiwarka dla sklepu internetowego',
  subtitle: 'Szybkie i precyzyjne wyniki dla Twoich klientów',
  description: [
    'Nasza zaawansowana wyszukiwarka zapewnia błyskawiczne i trafne wyniki, nawet w przypadku literówek czy błędów w pisowni. Dzięki wykorzystaniu zaawansowanych technologii, takich jak synonimy i filtry, możesz być pewny, że Twoi klienci znajdą dokładnie to, czego szukają – szybko i efektywnie.',
  ],
  features: [
    {
      title: 'Ultra-Szybka Wydajność',
      description:
        'Nasza wyszukiwarka działa błyskawicznie, nawet przy dużych bazach danych. Dzięki temu klienci mogą szybko przeszukiwać Twoją ofertę, co zwiększa ich zadowolenie i konwersje.',
    },
    {
      title: 'Zarządzanie Literówkami i Błędami',
      description:
        'System inteligentnie radzi sobie z literówkami i błędami w pisowni, zapewniając trafne wyniki wyszukiwania mimo drobnych pomyłek użytkowników.',
    },
    {
      title: 'Zaawansowane Opcje Filtrowania',
      description:
        'Nasza wyszukiwarka oferuje rozbudowane opcje filtrowania, które umożliwiają precyzyjne dopasowanie wyników do potrzeb użytkowników. Możesz łatwo dostosować filtry do specyfiki swojego asortymentu i preferencji klientów.',
    },
    {
      title: 'Personalizacja Wyników',
      description:
        'Dzięki możliwości dostosowania pod preferencje użytkowników, nasza wyszukiwarka umożliwia prezentowanie spersonalizowanych wyników, co poprawia doświadczenia zakupowe i zwiększa sprzedaż.',
    },
    {
      title: 'Uczenie Maszynowe i Analiza Zachowań',
      description:
        'Nasze rozwiązanie uczy się na podstawie zachowań klientów i analizuje ich interakcje, co pozwala na ciągłe doskonalenie wyników wyszukiwania oraz rekomendacji produktowych.',
    },
    {
      title: 'Integracja z ChatGPT',
      description:
        'Wykorzystując API ChatGPT do generowania synonimów, możemy dostosować wyniki wyszukiwania, aby użytkownicy z pewnością znaleźli odpowiednie produkty w Twoim sklepie. Synonimy dla każdego produktu będą automatycznie tworzone, co ułatwi ich odnalezienie.',
    },
  ],
  cta: {
    title: 'Zwiększ Sprzedaż i Popraw Wyszukiwanie',
    description:
      'Zwiększ wskaźnik konwersji i średnią wartość zamówień dzięki naszemu zaawansowanemu rozwiązaniu wyszukiwania. Spersonalizowane rekomendacje i szybkie wyniki wyszukiwania prowadzą do szybszych decyzji zakupowych i lepszego doświadczenia klienta.',
    button_text: 'Skontaktuj się z nami',
    button_link: '/pl/contact',
  },
}

const en = {
  title: 'Blink Find - Search for E-Commerce',
  subtitle: 'Extreme Speed, Precision, and Personalization',
  description: [
    'Our advanced search engine provides lightning-fast and accurate results, even in the case of typos or spelling errors. By leveraging advanced technologies such as synonyms and filters, you can be sure that your customers will find exactly what they are looking for—quickly and effectively.',
  ],
  features: [
    {
      title: 'Ultra-Fast Performance',
      description:
        'Our search engine operates at lightning speed, even with large databases. This ensures that customers can quickly browse your offerings, increasing their satisfaction and conversions.',
    },
    {
      title: 'Handling Typos and Errors',
      description:
        'The system intelligently handles typos and spelling mistakes, providing accurate search results despite minor user errors.',
    },
    {
      title: 'Advanced Filtering Options',
      description:
        'Our search engine offers extensive filtering options that allow precise matching of results to user needs. You can easily customize filters to fit your product assortment and customer preferences.',
    },
    {
      title: 'Personalized Results',
      description:
        'With the ability to tailor results to user preferences, our search engine enables personalized result presentations, enhancing shopping experiences and boosting sales.',
    },
    {
      title: 'Machine Learning and Behavior Analysis',
      description:
        'Our solution learns from customer behaviors and analyzes their interactions, allowing continuous improvement of search results and product recommendations.',
    },
    {
      title: 'API Integration',
      description:
        'By using advanced APIs, including options like synonyms offered by ChatGPT, you can tailor the search engine functionality to the unique needs of your business.',
    },
  ],
  cta: {
    title: 'Boost Sales and Improve Search',
    description:
      'Increase conversion rates and average order values with our advanced search solution. Personalized recommendations and fast search results lead to quicker purchasing decisions and a better customer experience.',
    button_text: 'Contact Us',
    button_link: '#contact',
  },
}

const langs = { pl, en }

const BlinkFrontend = () => {
  const data = langs[lan]
  const { title, subtitle, description, features, cta } = data

  return (
    <>
      <SEO title={title} />

      <Header />
      <Box className={`section`}>
        <Box className={`sectionInner`} style={{ maxWidth: '800px' }}>
          <h1>{title}</h1>
          <h2>{subtitle}</h2>
          <p>{description[0]}</p>
          <div>
            {features.map((feature, index) => (
              <div key={index}>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
          <div>
            <h2>{cta.title}</h2>
            <p>{cta.description}</p>
            <a href={cta.button_link}>{cta.button_text}</a>
          </div>
        </Box>
      </Box>
    </>
  )
}

export default BlinkFrontend
